import { create } from 'zustand';

export type Section = 'jour' | 'planning' | 'eleves';

interface BilanTarget {
  candidateId: string;
  candidateName: string;
  lessonId?: string;
}

interface UiState {
  section: Section;
  setSection: (s: Section) => void;

  bilanTarget: BilanTarget | null;
  openBilan: (target: BilanTarget) => void;
  closeBilan: () => void;

  livretStudentId: string | null;
  openLivret: (id: string) => void;
  closeLivret: () => void;
}

export const useUiStore = create<UiState>((set) => ({
  section: 'jour',
  setSection: (section) => set({ section }),

  bilanTarget: null,
  openBilan: (bilanTarget) => set({ bilanTarget }),
  closeBilan: () => set({ bilanTarget: null }),

  livretStudentId: null,
  openLivret: (livretStudentId) => set({ livretStudentId }),
  closeLivret: () => set({ livretStudentId: null }),
}));
